import React, { useEffect, useState } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import InfoIcon from "../support_files/InfoIcon";
import HelpIcon from "../support_files/HelpIcon";
import ToggleButton from '@mui/material/ToggleButton';
import Fade from '@mui/material/Fade';
import AncestryInfoDrawer from "../info_components/AncestryInfo"

function CheckBoxChild({ ancestry, onClick, label, color, childActiveAncestryAll }) {
    return (
        <div className="raceContainer">

            <FormControlLabel
                control={
                    <Checkbox
                        id={ancestry.ancestry}
                        checked={ancestry.selected}
                        // disabled={childActiveAncestryAll ? true : false}
                        onChange={(event) => {
                            onClick({
                                ...ancestry,
                                selected: event.target.checked,
                            });
                        }}
                        sx={{
                            padding: "0px 0 0 0"
                            , "& .MuiSvgIcon-root": {
                                fontSize: 28,
                                color: { color },
                            }
                        }}
                    />}
                sx={{
                    "& .MuiTypography-root": {
                        lineHeight: "1.3"
                    }
                }}
                label={label}
            >
            </FormControlLabel>
        </div>

    )
}


function CheckBoxParent({ group, onClick, label, color, children, onClickChild, activeAncestryAll }) {
    return (
        <div className="checkBoxParentContainer">
            <div className="checkBoxParent">
                <div className="raceContainer">

                    <FormControlLabel sx={{
                        "& .MuiTypography-root": {
                            fontWeight: "600"
                        }
                    }}
                        control={
                            <Checkbox
                                id={group.ancestry_group}
                                checked={group.selected}
                                // disabled={activeAncestryAll ? true : false}
                                indeterminate={group.indeterminate}
                                onChange={(event) => {
                                    onClick({
                                        ancestry_group: group.ancestry_group,
                                        color: group.color,
                                        selected: event.target.checked,
                                    });
                                }}
                                sx={{
                                    padding: "2px"
                                    , "& .MuiSvgIcon-root": {
                                        fontSize: 28,
                                        color: { color },
                                    }
                                    , "& .MuiTypography-root": {
                                        padding: "20px"
                                    }
                                }}
                            />}
                        label={label}
                    >
                    </FormControlLabel>
                </div>


                <div className="checkBoxChild">
                    {children.map((child) => (
                        <CheckBoxChild
                            key={child.ancestry}
                            ancestry={child}
                            childActiveAncestryAll={activeAncestryAll}
                            // ancestry_group={child.ancestry_group}
                            label={child.ancestry}
                            color={child.color}
                            onClick={onClickChild}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

function ResetBox({ select, onClick }) {
    return (
        <div className="openToAllBox">
            <FormControlLabel
                control=
                {<Checkbox
                    id="open_to_all"
                    checked={select}
                    // {...select === "indeterminate" && {indeterminate:true}}
                    onChange={(event) => {
                        onClick("ancestry", event.target.checked);
                    }}
                    sx={{
                        padding: "2px"
                        , "& .MuiSvgIcon-root": {
                            fontSize: 28,
                            color: "#D8D8D8",
                        }
                    }}
                ></Checkbox>}
                label="Open to All"
                sx={{
                    "& .MuiTypography-root": {
                        fontWeight: "600"
                    }
                }}
            >
            </FormControlLabel>
        </div>
    )
}

export default function Ancestry({ activeAncestry, onAncestryClick, activeAncestryGroup, onAncestryGroupClick, activeAncestryAll, resetter }) {
    // Prepare data by organizing ethnicities into respective groups and inserting those nested objects into an array.
    const organizedAncestry = []
    const ancestryOrganizer = activeAncestryGroup.map((group) => {
        const ancestryChildren = []
        activeAncestry.map((ancestry) => {
            if (ancestry.ancestry_group === group.ancestry_group) {
                ancestryChildren.push(ancestry)
            }
        })
        organizedAncestry.push({ ...group, "children": ancestryChildren })
    }
    );
    const [selectedInfo, setSelectedInfo] = useState(false);
    const [selectedHelp, setSelectedHelp] = useState(false);

    // First we loop through each ancestry group and provide both ancestry group props and the ancestry children props.
    return (
        <div className="componentContainer" style={{ paddingTop: "10px" }}>
            <div className="genderContainerSlim">
                <Fade
                    // in={false ? true : false}
                    in={selectedHelp ? true : false}
                    timeout={500}
                >
                    <div className="helpContainer" style={{ height: "180px" }} onClick={() => { setSelectedHelp(!selectedHelp) }}>
                        <div className="helpBox">
                            <h2 className="helpText">Tips</h2>
                            <p className="helpText">- 🌻 Only one level of specificity may be selected, with Race representing the broadest category and Ancestry the most precise.</p>
                            <p className="helpText">- ✅ This is the final criteria on this page. When finished, select "2. My Estimates" at the top.</p>
                        </div>
                    </div>
                </Fade>
                <AncestryInfoDrawer selectedInfo={selectedInfo} setSelectedInfo={setSelectedInfo} />

                <div className="componentHeaderContainerSlim">
                    <div className="componentHeader">
                        <div className="descriptionContainer">
                            <p className="description">Desired ancestry for partner</p>

                            {/* <p className="note">The ancestry or ethnicity group that one identifies with, not necessarily their country of birth</p> */}


                        </div>
                        <div className="info">
                            <ToggleButton
                                    value={1}
                                    selected={selectedInfo}
                                    onChange={() => setSelectedInfo((prevSelected) => !prevSelected)}
                                    sx={{ padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected":{backgroundColor: "rgb(45 185 255 / 17%)"} }}
                                >
                                    <InfoIcon />
                                </ToggleButton>
                            <ToggleButton
                                value={1}
                                selected={selectedHelp}
                                onChange={() => {setSelectedHelp((prevSelected) => !prevSelected);  setSelectedInfo(false)}}
                                sx={{ zIndex: 11, padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgba(87, 156, 202, 1)" } }}
                            >
                                <HelpIcon />
                            </ToggleButton>
                        </div>
                    </div>
                </div>
                <div>
                    <p className="sourceSlim">Source: U.S. Census Bureau, 2020 Decennial Census, NYC</p>
                </div>
            </div>


            <div className="openAllBox">
                <div className="scrollHUD">
                    <ArrowCircleRightOutlinedIcon sx={{ color: "#DDDDDD", fontSize: "28px" }} />
                </div>
            </div>

            <div className="checkBoxContainer">
                <div className="openAllBox">
                    <ResetBox key="open_to_all" select={activeAncestryAll} onClick={resetter} />
                </div>


                {organizedAncestry.map((group) => (
                    <CheckBoxParent
                        key={group.ancestry_group}
                        group={group}
                        label={group.ancestry_group}
                        color={group.color}
                        onClick={onAncestryGroupClick}
                        activeAncestryAll={activeAncestryAll}

                        children={group.children}
                        onClickChild={onAncestryClick}
                    />
                ))}
            </div>
            {/* <div className="scrollHUD">
                    <p style={{ color: "#cccccc", fontSize: "16px", fontWeight: "500" }}>Scroll</p>
                    <ArrowForwardIcon sx={{ color: "#cccccc" }} />
                </div> */}
        </div>
    );
}